<div class="settings-layout">
  <div class="d-flex justify-content-between">
    <aside class="settings-menu">
      <app-shared-menu [options]="{ class: 'settings-layout-menu', menuType: 'aside' }"></app-shared-menu>
    </aside>
    <div class="settings-body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
